import { Component } from "@angular/core";

@Component({
    selector:'account-main',
    template:`<router-outlet></router-outlet>`
})
export class AccountLayoutComponent {

}